module.exports = __webpack_public_path__ + "static/media/bishopernestpalmer.9610fc79.PNG";